import { Section, Stack, Text } from '@/ui';
import { PageShell } from '@/ui/primitives/PageShell';
import type { ReactElement } from 'react';

export const DocsPage = (): ReactElement => (
  <PageShell maxWidth="md" paddingX="lg" paddingY="xl" paddingBottom="xl">
    <Stack gap="xl">
      <Section>
        <Stack gap="sm">
          <Text role="pageTitle">Docs</Text>
          <Text role="bodyMuted">Documentation content goes here.</Text>
        </Stack>
      </Section>
    </Stack>
  </PageShell>
);
